import React from 'react';

import type { LucideIcon } from 'lucide-react';

import { iconComponents } from '../IconImports';

type SvgIconComponent = React.ComponentType<React.SVGProps<SVGSVGElement>>;
type IconComponent = LucideIcon | SvgIconComponent;

interface IconProps {
  name: keyof typeof iconComponents;
  className?: string;
  style?: React.CSSProperties;
  /** When set, icon is meaningful; otherwise decorative (aria-hidden). */
  ariaLabel?: string;
}

export const Icon: React.FC<IconProps> = ({ name, className, style, ariaLabel }) => {
  const SelectedIcon = iconComponents[name] as IconComponent | undefined;

  if (!SelectedIcon) {
    console.warn(`Icon with name "${name}" does not exist. Please check the name.`);

    return 'N/D';
  }

  // Lucide defaults to strokeWidth 2; SVGR icons ignore this prop on the root element.
  const iconProps = {
    className,
    strokeWidth: 1,
    style,
  };

  if (ariaLabel) {
    return <SelectedIcon aria-label={ariaLabel} role="img" {...iconProps} />;
  }

  return <SelectedIcon aria-hidden="true" {...iconProps} />;
};
